// Ensure that the browser supports the service worker API
if (navigator.serviceWorker) {
  // Start registration process on every page load
  window.addEventListener('load', () => {
      navigator.serviceWorker
          // The register function takes as argument
          // the file path to the worker's file
          .register('/service-worker.js')
          // Gives us registration object
          .then(reg => console.log('Service Worker Registered'))
          .catch(swErr => console.log(
                `Service Worker Installation Error: ${swErr}}`));
    });
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    if(error.response) {
        if(error.response.status == 422 && error.response.data && error.response.data.message) { // some validation error
            window.vm.$notify({
                text: error.response.data.message,
                type: 'success',
            })
        } else if(error.response.status == 403 && error.response.data && error.response.data.message) { // some permissions error
            window.vm.$notify({
                text: error.response.data.message,
                type: 'error',
            })
        } else {
            window.vm.$notify({
                text: `${window.vm.$t('error')} (#${error.response.status})`,
                type: 'error',
            })
        }
    }
    return Promise.reject(error);
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo"

window.Pusher = require('pusher-js/with-encryption');
/*
window.Pusher.log = (message) => {
    if (window.console && window.console.log) {
        window.console.log(message);
    }
};
*/

import { Howl, Howler } from 'howler';

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true,
    activityTimeout: 10000,
    encrypted: true,
});

var moment = window.moment = require('moment');

/*
import * as PusherPushNotifications from "@pusher/push-notifications-web";

const beamsClient = new PusherPushNotifications.Client({
    instanceId: "bbb63972-59cb-4d35-a0e3-83c9c0463548",
});

beamsClient.start().then(() => {
    beamsClient.start()
        .then(() => beamsClient.addDeviceInterest('debug-news'))
        .then(() => beamsClient.addDeviceInterest('debug-live'))
        .then(() => beamsClient.addDeviceInterest('debug-reminders'))
        .then(() => console.log('Successfully registered and subscribed!'))
        .catch(console.error);
});
*/

window.ding = new Howl({
    src: ['/live/sounds/ding.mp3', '/live/sounds/ding.ogg'],
    mute: true,
});

window.outbid = new Howl({
    src: ['/live/sounds/outbid.mp3', '/live/sounds/outbid.ogg'],
    mute: true,
});

window.highest = new Howl({
    src: ['/live/sounds/highest.mp3', '/live/sounds/highest.ogg'],
    mute: true,
});

window.congrats = new Howl({
    src: ['/live/sounds/congrats.mp3', '/live/sounds/congrats.ogg'],
    mute: true,
});

window.onetime = new Howl({
    src: ['/live/sounds/once.mp3', '/live/sounds/once.ogg'],
    mute: true,
});

window.twice = new Howl({
    src: ['/live/sounds/twice.mp3', '/live/sounds/twice.ogg'],
    mute: true,
});

window.three = new Howl({
    src: ['/live/sounds/three.mp3', '/live/sounds/three.ogg'],
    mute: true,
});

window.lotopen = new Howl({
    src: ['/live/sounds/open.mp3', '/live/sounds/open.ogg'],
    mute: true,
});

window.lotsold = new Howl({
    src: ['/live/sounds/sold.mp3', '/live/sounds/sold.ogg'],
    mute: true,
});
